<rask-button
    color="secondary"
    [autoClose]="'outside'"
    tooltip-placement="top-left"
    [ngbPopover]="selectedItemsPopup">{{getButtonText()}}</rask-button>

<ng-template #selectedItemsPopup>
    <rask-container-block>
        <ng-container header>Markerade ({{data.length}})</ng-container>
            <rask-list [data]="data" [showHeader]="false">
                <rask-list-column header="vald" field="checked" width="10%">
                    <ng-template let-row="row">
                        <rask-checkbox
                            class="row-checkbox"
                            [(ngModel)]="row.checked"
                            (change)="removeFromList(row)">
                        </rask-checkbox>
                    </ng-template>
                </rask-list-column>
                <rask-list-column width="80%" header="beteckning" field="beteckning"></rask-list-column>
                <rask-list-column width="10%">
                    <ng-template let-row="row">
                        <rask-icon-button (click)="removeFromList(row)" icon="far fa-trash-alt" negative></rask-icon-button>
                    </ng-template>
                </rask-list-column>
            </rask-list>
</rask-container-block>
</ng-template>
